<div class="sk-cms-richtext"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title}) %>
    {{/if}}
    {{if !content.html || !content.html.length}}
         <% include('../common/nodata.art') %>
    {{else}}
        <div class="richtext-main ck-content">
        {{@content.html}}
        </div>
    {{/if}}
</div>